module.exports = __webpack_public_path__ + "img/kaist_gallery8.c3878fea.jpg";